import { HTTP } from '../../services/api-service.js'
import commonObj from '../../services/common.js'
const common = new commonObj();
const baseURL = common.baseURL

const todolistStore = {
  namespaced: true,
  actions: {
    getTodolist({ commit, state }, params) {
      return new Promise((resolve,reject) => {
        HTTP.post(baseURL + '/todo/ToDoList', params).then(resp => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },
    saveTodolist({commit, state}, params){
      return new Promise((resolve, reject) =>{
        HTTP.post(baseURL + '/todo/SaveToDoList', params).then(resp => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },
    deleteTodolist({ commit, state }, params) {
      return new Promise((resolve, reject) => {
        HTTP.post(baseURL + '/todo/DeleteToDoList', params).then(resp => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    }
  }
}

export default todolistStore;